import { IComponentOptions } from 'angular';
import { RastreamentoDetalhesReversaController } from './rastreamento-detalhes-reversa.controller';

/**
 * @type {IComponentOptions}
 */
export const RastreamentoDetalhesReversaComponent = {
  controller: RastreamentoDetalhesReversaController,
  controllerAs: '$ctrl',
  template: require('./rastreamento-detalhes-reversa.component.html'),
  bindings: {
    encomenda: '<',
  }
};
